import { NavLink, useNavigate } from "react-router-dom";
import "./LeftMenu.css";
import { isSuperAdmin } from "../Auth/auth";

export default function LeftMenu() {
  const navigate = useNavigate();
  const userName = localStorage.getItem("userName") || "Guest";
  const showAdminTabs = isSuperAdmin();

  return (
    <aside className="lm">
      <div className="lm-brand" onClick={() => navigate("/dashboard")}>
        <div className="logo">⚡</div>
        <div>
          <div className="title">Admin Console</div>
          <div className="sub">User & Subscription</div>
        </div>
      </div>

      <nav className="lm-nav">
        <NavLink to="/dashboard" className="item">Dashboard</NavLink>
        {showAdminTabs && (
          <>
            <NavLink to="/admin-users" className="item">Admin Users</NavLink>
            <NavLink to="/roles" className="item">Roles</NavLink>
          </>
        )}
      </nav>

      <div className="lm-bottom">
        <div className="avatar">{userName?.[0]?.toUpperCase()}</div>
        <div className="who">{userName}</div>
      </div>
    </aside>
  );
}
